import { handleActions } from "redux-actions";

import {
    CAMPAIGN_FETCH_START,
    CAMPAIGN_FETCH_FAILURE,
    CAMPAIGN_FETCH_SUCCESS,
    CAMPAIGN_RESET,
    CAMPAIGN_EDIT_START,
    CAMPAIGN_EDIT_SUCCESS,
} from "constants/action-types";

const initialState = {
    result: [],
    isFetching: false,
    error: undefined,
    errorMessage: "",
};

const campaignReducer = handleActions<any>(
    {
        [CAMPAIGN_FETCH_START]: (state: object): object => {
            return Object.assign({}, state, {
                result: [],
                isFetching: true,
            });
        },
        [CAMPAIGN_FETCH_SUCCESS]: (state: object, { payload }): object => {
            return Object.assign({}, state, {
                result: [payload],
                isFetching: false,
            });
        },
        [CAMPAIGN_FETCH_FAILURE]: (state: object, { payload, error }): object => {
            return Object.assign({}, state, {
                isFetching: false,
                error: error,
                errorMessage: payload,
            });
        },
        [CAMPAIGN_RESET]: (): object => {
            return initialState;
        },
        [CAMPAIGN_EDIT_START]: (state: object, { payload }): object => {
            return Object.assign({}, state, { isDeleting: payload.id });
        },
        [CAMPAIGN_EDIT_SUCCESS]: (state: object): object => {
            return Object.assign({}, state, { isDeleting: "" });
        },
    },
    initialState,
);

export default campaignReducer;
